var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.isWide ? "" : _vm.additionalClasses }, [
    _c(
      "div",
      {
        class: [
          "row mb-2 p-md-1",
          _vm.isSosh ? "text-dark" : "text-white",
          _vm.isSosh ? "bg-gray2" : "bg-dark",
        ],
      },
      [
        _c(
          "div",
          {
            staticClass:
              "col-12 col-md-2 d-flex justify-content-center align-items-md-center",
          },
          [
            _c("img", {
              staticClass: "alert-icon logo-tuile-5g py-1 py-md-0",
              attrs: { src: _vm.image, alt: "logo 5G", "aria-hidden": "true" },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6" },
          [
            _c("h2", { staticClass: "h4 pt-1 pt-md-2 pb-1 mb-0 ps-0" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.title) + "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("ob1-liste-a-puces", {
              attrs: { "liste-a-puces-dto": _vm.list },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-md-4 d-flex text-center justify-content-center align-items-md-center pb-2 pb-md-0",
          },
          [
            _c("ob1-boutons", {
              attrs: {
                label: _vm.link.text,
                target: _vm.link.target,
                href: _vm.link.href,
                "is-button": false,
                "is-inverse": "",
                "is-secondary": "",
                "data-oevent-category": "zone_info_5g",
                "data-oevent-action": _vm.getLabelToTmsFormat(_vm.link.text),
                "data-oevent-label": _vm.link.href,
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }